__turbopack_context__.v({
  "className": "open_sans_da505759-module__8l8kGW__className",
  "variable": "open_sans_da505759-module__8l8kGW__variable",
});
